<aaa-file-manager-upload
  *ngIf="fileList.length"
  [directory]="directory"
  [fileList]="fileList"
></aaa-file-manager-upload>
